import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './index.module.scss';
type Props = {
  iconName?: string | null;
  isInfo?: boolean;
  className?: string;
};
const ASSETS = process.env.NEXT_PUBLIC_ASSETS_BASE_URL;
const maskStyle = (file: string, isInfo: boolean): React.CSSProperties => {
  const path = `${ASSETS}/static/icons/badges${isInfo ? '/info' : ''}/${file}.svg`;
  return {
    maskImage: `url(${path})`
  };
};
export const SvgIcon = t0 => {
  const $ = _c(8);
  const {
    iconName,
    isInfo: t1,
    className
  } = t0;
  const isInfo = t1 === undefined ? false : t1;
  if (!iconName) {
    return;
  }
  let t2;
  if ($[0] !== className) {
    t2 = classNames(styles.maskIcon, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== iconName || $[3] !== isInfo) {
    t3 = maskStyle(iconName, isInfo);
    $[2] = iconName;
    $[3] = isInfo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2} style={t3} aria-hidden="true" />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};